import axios from '@/utils/request'
import base from '@/api/base'

/**
 * 客服身份与在线状态（controller/agent：/v1/agent/**，经网关 /service/v1/agent/**）
 */

/** 以登录账号加载客服档案（含 cs:* 权限码）；Authorization 由 request.js 自动注入 */
export function getAgentByUsername(userName) {
  return axios.get(`${base.url}/service/v1/agent/by-username/${encodeURIComponent(userName)}`)
}

/** 客服上下线（status: 0 离线 / 1 在线） */
export function updateAgentStatus(agentId, status) {
  return axios.post(`${base.url}/service/v1/agent/${agentId}/status`,
    JSON.stringify({ status }),
    { headers: { 'Content-Type': 'application/json' } })
}

/** 更新客服头像 */
export function updateAgentProfile(agentId, data) {
  return axios.put(`${base.url}/service/v1/agent/${agentId}/profile`,
    JSON.stringify(data),
    { headers: { 'Content-Type': 'application/json' } })
}

/** 修改客服密码 */
export function changeAgentPassword(agentId, data) {
  return axios.put(`${base.url}/service/v1/agent/${agentId}/password`,
    JSON.stringify(data),
    { headers: { 'Content-Type': 'application/json' } })
}